import {Chip} from '@mui/material';
import React from 'react';

const DemoStudentChip = () => (
  <Chip
    label="Demo"
    size="small"
    color="default"
    sx={{ml: 1, height: 18, maxHeight: 18}}
  />
);

export default DemoStudentChip;
